import React, {
  useEffect,
  useState
} from "react";

import {
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  makeStyles
} from "@material-ui/core";

import {
  Formik,
  Form,
  Field
} from "formik";

import {
  Edit as EditIcon
} from "@material-ui/icons";

import {
  toast
} from "react-toastify";

import ButtonWithSpinner
  from "../ButtonWithSpinner";

import ConfirmationModal
  from "../ConfirmationModal";

import useHelps
  from "../../hooks/useHelps";

const useStyles =
  makeStyles(theme => ({
    root: {
      width: "100%"
    },

    mainPaper: {
      width: "100%",
      flex: 1,
      padding: theme.spacing(2)
    },

    fullWidth: {
      width: "100%"
    },

    tableContainer: {
      width: "100%",
      overflowX: "auto",
      ...theme.scrollbarStyles
    },

    sectionTitle: {
      marginBottom:
        theme.spacing(2)
    },

    helper: {
      marginBottom:
        theme.spacing(2),
      color:
        theme.palette.text.secondary
    },

    buttonContainer: {
      textAlign: "right",
      padding: theme.spacing(1)
    }
  }));

const categories = [
  "Geral",
  "Primeiros passos",
  "Atendimento",
  "Conexões e WhatsApp",
  "Usuários e permissões",
  "Filas e equipes",
  "Contatos",
  "Financeiro",
  "Armazenamento",
  "Configurações",
  "Integrações",
  "API"
];

const emptyRecord = {
  title: "",
  description: "",
  video: "",
  link: "",
  category: "Geral",
  route: "",
  contextKey: "",
  sortOrder: 0
};

export function HelpManagerForm(
  props
) {
  const {
    onSubmit,
    onDelete,
    onCancel,
    initialValue,
    loading
  } = props;

  const classes =
    useStyles();

  const [record, setRecord] =
    useState(
      initialValue
    );

  useEffect(
    () => {
      setRecord(
        initialValue
      );
    },
    [
      initialValue
    ]
  );

  return (
    <Formik
      enableReinitialize
      initialValues={record}
      onSubmit={values => {
        onSubmit({
          ...values,

          sortOrder:
            Math.max(
              Number(
                values.sortOrder
              ) || 0,
              0
            )
        });
      }}
    >
      <Form
        className={
          classes.fullWidth
        }
      >
        <Typography
          variant="h6"
          className={
            classes.sectionTitle
          }
        >
          Conteúdo da Central de Ajuda
        </Typography>

        <Typography
          variant="body2"
          className={
            classes.helper
          }
        >
          Cadastre explicações,
          vídeos e links que serão
          exibidos aos clientes.
          A rota permite relacionar
          o conteúdo a uma tela
          específica do sistema.
        </Typography>

        <Grid
          spacing={2}
          container
        >
          <Grid
            xs={12}
            md={5}
            item
          >
            <Field
              as={TextField}
              label="Título"
              name="title"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              required
            />
          </Grid>

          <Grid
            xs={12}
            md={4}
            item
          >
            <Field
              as={TextField}
              select
              label="Categoria"
              name="category"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
            >
              {categories.map(
                category => (
                  <MenuItem
                    key={category}
                    value={category}
                  >
                    {category}
                  </MenuItem>
                )
              )}
            </Field>
          </Grid>

          <Grid
            xs={12}
            md={3}
            item
          >
            <Field
              as={TextField}
              type="number"
              label="Ordem"
              name="sortOrder"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              inputProps={{
                min: 0
              }}
              helperText="Menor número aparece primeiro"
            />
          </Grid>

          <Grid
            xs={12}
            md={4}
            item
          >
            <Field
              as={TextField}
              label="Tela / rota"
              name="route"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              placeholder="/connections"
              helperText="Ex.: /connections, /users, /financeiro"
            />
          </Grid>

          <Grid
            xs={12}
            md={4}
            item
          >
            <Field
              as={TextField}
              label="Contexto interno"
              name="contextKey"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              placeholder="connections.nps"
              helperText="Opcional. Identifica uma aba, modal ou função interna."
            />
          </Grid>

          <Grid
            xs={12}
            md={4}
            item
          >
            <Field
              as={TextField}
              label="ID do vídeo do YouTube"
              name="video"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              helperText="Opcional. Use somente o código do vídeo."
            />
          </Grid>

          <Grid
            xs={12}
            md={4}
            item
          >
            <Field
              as={TextField}
              label="Link complementar"
              name="link"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              placeholder="https://..."
              helperText="Opcional"
            />
          </Grid>

          <Grid
            xs={12}
            item
          >
            <Field
              as={TextField}
              label="Explicação / descrição"
              name="description"
              variant="outlined"
              className={
                classes.fullWidth
              }
              margin="dense"
              multiline
              minRows={3}
              helperText="Explique de forma simples como a função é usada na prática."
            />
          </Grid>

          <Grid
            xs={12}
            item
            className={
              classes.buttonContainer
            }
          >
            <ButtonWithSpinner
              loading={loading}
              onClick={
                onCancel
              }
              variant="contained"
              style={{
                marginRight: 8
              }}
            >
              Limpar
            </ButtonWithSpinner>

            {record.id !==
              undefined && (
              <ButtonWithSpinner
                loading={loading}
                onClick={() =>
                  onDelete(record)
                }
                variant="contained"
                color="secondary"
                style={{
                  marginRight: 8
                }}
              >
                Excluir
              </ButtonWithSpinner>
            )}

            <ButtonWithSpinner
              loading={loading}
              type="submit"
              variant="contained"
              color="primary"
            >
              Salvar
            </ButtonWithSpinner>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
}

export function HelpsManagerGrid(
  props
) {
  const {
    records,
    onSelect
  } = props;

  const classes =
    useStyles();

  return (
    <Paper
      className={
        classes.tableContainer
      }
    >
      <Table
        className={
          classes.fullWidth
        }
        size="small"
      >
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
            >
              #
            </TableCell>

            <TableCell>
              Título
            </TableCell>

            <TableCell>
              Categoria
            </TableCell>

            <TableCell>
              Tela
            </TableCell>

            <TableCell>
              Contexto
            </TableCell>

            <TableCell
              align="center"
            >
              Ordem
            </TableCell>

            <TableCell>
              Vídeo
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {records.map(
            row => (
              <TableRow
                key={row.id}
              >
                <TableCell
                  align="center"
                >
                  <IconButton
                    onClick={() =>
                      onSelect(row)
                    }
                    aria-label="Editar"
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>

                <TableCell>
                  {row.title ||
                    "-"}
                </TableCell>

                <TableCell>
                  {row.category ||
                    "Geral"}
                </TableCell>

                <TableCell>
                  {row.route ||
                    "Todas"}
                </TableCell>

                <TableCell>
                  {row.contextKey ||
                    "-"}
                </TableCell>

                <TableCell
                  align="center"
                >
                  {row.sortOrder ??
                    0}
                </TableCell>

                <TableCell>
                  {row.video ||
                    "-"}
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default function HelpsManager() {
  const classes =
    useStyles();

  const {
    list,
    save,
    update,
    remove
  } =
    useHelps();

  const [
    showConfirmDialog,
    setShowConfirmDialog
  ] =
    useState(false);

  const [
    loading,
    setLoading
  ] =
    useState(false);

  const [
    records,
    setRecords
  ] =
    useState([]);

  const [
    record,
    setRecord
  ] =
    useState(
      emptyRecord
    );

  const loadHelps =
    async () => {
      setLoading(true);

      try {
        const helpList =
          await list();

        setRecords(
          helpList
        );
      } catch (e) {
        toast.error(
          "Não foi possível carregar a lista de ajuda."
        );
      }

      setLoading(false);
    };

  useEffect(() => {
    loadHelps();

    // eslint-disable-next-line
  }, []);

  const handleCancel =
    () => {
      setRecord({
        ...emptyRecord
      });
    };

  const handleSubmit =
    async data => {
      setLoading(true);

      try {
        if (
          data.id !==
          undefined
        ) {
          await update(
            data
          );
        } else {
          await save(
            data
          );
        }

        await loadHelps();

        handleCancel();

        toast.success(
          "Conteúdo de ajuda salvo com sucesso!"
        );
      } catch (e) {
        toast.error(
          "Não foi possível salvar o conteúdo de ajuda."
        );
      }

      setLoading(false);
    };

  const handleDelete =
    async () => {
      setLoading(true);

      try {
        await remove(
          record.id
        );

        await loadHelps();

        handleCancel();

        toast.success(
          "Conteúdo excluído com sucesso!"
        );
      } catch (e) {
        toast.error(
          "Não foi possível excluir o conteúdo."
        );
      }

      setShowConfirmDialog(
        false
      );

      setLoading(false);
    };

  const handleSelect =
    data => {
      setRecord({
        id:
          data.id,

        title:
          data.title ||
          "",

        description:
          data.description ||
          "",

        video:
          data.video ||
          "",

        link:
          data.link ||
          "",

        category:
          data.category ||
          "Geral",

        route:
          data.route ||
          "",

        contextKey:
          data.contextKey ||
          "",

        sortOrder:
          data.sortOrder ??
          0
      });
    };

  return (
    <Paper
      className={
        classes.mainPaper
      }
      elevation={0}
    >
      <Grid
        spacing={3}
        container
      >
        <Grid
          xs={12}
          item
        >
          <HelpManagerForm
            initialValue={
              record
            }
            onDelete={() =>
              setShowConfirmDialog(
                true
              )
            }
            onSubmit={
              handleSubmit
            }
            onCancel={
              handleCancel
            }
            loading={
              loading
            }
          />
        </Grid>

        <Grid
          xs={12}
          item
        >
          <HelpsManagerGrid
            records={
              records
            }
            onSelect={
              handleSelect
            }
          />
        </Grid>
      </Grid>

      <ConfirmationModal
        title="Excluir conteúdo de ajuda"
        open={
          showConfirmDialog
        }
        onClose={() =>
          setShowConfirmDialog(
            false
          )
        }
        onConfirm={
          handleDelete
        }
      >
        Deseja realmente excluir
        este conteúdo da Central
        de Ajuda?
      </ConfirmationModal>
    </Paper>
  );
}
